/**
 * Feature Groups module
 *
 * Groups of tabular feature entries, each with a heading
 */

// Deps
import { createComponent, FelaComponent } from "react-fela";
import { combineRules } from "fela";
import { textStyles } from "~/styleguide/typography";
import { Container, faqHeading } from "~/components/blocks/faq";

// Components
import Group from "./group";
import { ContentMaxWidth } from "~/components/layout/max-width";

export default function FeatureGroups({ block }) {
    const { heading, groups, anchor_id } = block;

    return (
        <Container id={anchor_id} className="with-back module-feature-groups">
            <ContentMaxWidth>
                {/* Heading */}
                <FelaComponent
                    as="h3"
                    style={combineRules(textStyles.heading3, faqHeading)}
                >
                    <span dangerouslySetInnerHTML={{ __html: heading }} />
                </FelaComponent>

                {groups && groups.length && (
                    <Listing>
                        {groups &&
                            groups.map((group, index) => {
                                return <Group key={index} group={group} />;
                            })}
                    </Listing>
                )}
            </ContentMaxWidth>
        </Container>
    );
}

const Listing = createComponent(() => ({
    textAlign: "left"
}));
